import React, { FC, useMemo, useCallback, useState, memo } from 'react';
import { useLazyQuery } from '@apollo/client';
import _sortBy from 'lodash/sortBy';
import DropdownWithChildren from '@minecraft.dropdown-with-children';
import { SearchProjectSeriesDoc } from '@minecraft.graphql-operations';
import ErrorMessage from '@minecraft.error-message';
import { generateSelectOptionsBasedOnField } from '../../shared/utils';
import { FilterData } from '../../shared/types';

type Props = FilterData;

export const Series: FC<Props> = ({ name, label }) => {
  const [fetchMoreErr, setFetchMoreErr] = useState<string>(null);
  const [getSeries, { data, loading, error, fetchMore }] = useLazyQuery(SearchProjectSeriesDoc, {});

  const handleSeriesFetch = useCallback(
    (searchValue: string, offset, limit): void => {
      getSeries({
        variables: { input: { projectSeriesName: searchValue }, page: { pageNumber: offset, pageSize: limit } },
      });
    },
    [getSeries]
  );
  const handleSeriesFetchMore = useCallback(
    async (searchValue, offset, limit) => {
      await fetchMore({
        variables: {
          input: { projectSeriesName: searchValue },
          page: {
            pageNumber: offset,
            pageSize: limit,
          },
        },
      }).catch((e) => {
        setFetchMoreErr(e?.message);
        console.error('error fetching more series', e);
      });
    },
    [fetchMore]
  );

  const seriesOptions = useMemo(() => {
    return generateSelectOptionsBasedOnField(
      _sortBy(data?.searchProjectSeriesByOrg?.objects, 'seriesName'),
      'seriesName',
      false,
      undefined,
      false
    );
  }, [data]);

  return (
    <DropdownWithChildren
      withFormik
      withSearch
      withAutocomplete
      isMultipleSelect
      withSelectAll
      isLoading={loading}
      initialOffset={1}
      initialLimit={20}
      name={name}
      toggleLabel={label}
      optionsTotalCount={data?.searchProjectSeriesByOrg?.totalCount}
      options={seriesOptions}
      onOptionsFetch={handleSeriesFetch}
      onOptionsFetchMore={handleSeriesFetchMore}
    >
      {(error || fetchMoreErr) && <ErrorMessage error={error || { message: fetchMoreErr }} />}
    </DropdownWithChildren>
  );
};

export default memo(Series);
